var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIssuesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79212 4.52018L9.99878 14.218L18.2053 4.52032C15.5885 2.59169 12.858 1.65115 9.99878 1.65115C7.13919 1.65115 4.40864 2.59166 1.79212 4.52018ZM0.517905 3.41202C3.46698 1.15471 6.63282 -0.000244141 9.99878 -0.000244141C13.3648 -0.000244141 16.5309 1.15505 19.4806 3.41296L19.4957 3.42452L19.5103 3.43677C20.0739 3.91096 20.1751 4.74764 19.6876 5.32509L11.0126 15.5764C10.8879 15.7235 10.7321 15.8423 10.5572 15.9233C10.3822 16.0044 10.1916 16.0464 9.99878 16.0464C9.80592 16.0464 9.61539 16.0044 9.44041 15.9233C9.26541 15.8423 9.11018 15.7241 8.98547 15.577L0.297155 5.31L0.28455 5.29348C-0.158992 4.71244 -0.0858679 3.8755 0.516996 3.41272L0.517905 3.41202Z",
    fill: "#192048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 3.2108C10.4559 3.2108 10.8256 3.58048 10.8256 4.0365V7.70627C10.8256 8.16229 10.4559 8.53197 9.9999 8.53197C9.54388 8.53197 9.1742 8.16229 9.1742 7.70627V4.0365C9.1742 3.58048 9.54388 3.2108 9.9999 3.2108ZM10.5645 9.38798C10.9019 9.69473 10.9268 10.2169 10.62 10.5544L10.6109 10.5645C10.3041 10.9019 9.78192 10.9268 9.44448 10.62C9.10705 10.3133 9.08218 9.79107 9.38892 9.45363L9.3981 9.44354C9.70484 9.10611 10.2271 9.08123 10.5645 9.38798Z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuesIcon);
export default __webpack_public_path__ + "static/media/IssuesIcon.8a9dfff69f30318fd5af30c0947c5f6f.svg";
export { ForwardRef as ReactComponent };